export const DIALOG_OPENED = 'BOARD_TRANSLATIONS_DIALOG_OPENED';
export const DIALOG_CLOSED = 'BOARD_TRANSLATIONS_DIALOG_CLOSED';

export const LOAD = 'BOARD_TRANSLATIONS_LOAD_DATA';
export const LOAD_DONE = 'BOARD_TRANSLATIONS_LOAD_DATA_DONE';
export const DISCONNECT = 'BOARD_TRANSLATIONS_DISCONNECT';

export const TRANSLATE_BOARD = 'TRANSLATE_BOARD';
export const TRANSLATE_BOARD_DONE = 'TRANSLATE_BOARD_DONE';
export const TRANSLATE_BOARD_FAILED = 'TRANSLATE_BOARD_FAILED';

//For single board re-translation
export const RETRANSLATE_BOARD = 'RETRANSLATE_BOARD';
export const RETRANSLATE_BOARD_DONE = 'RETRANSLATE_BOARD_DONE';
export const RETRANSLATE_BOARD_FAILED = 'RETRANSLATE_BOARD_FAILED';

//For multiple boards re-translation
export const RE_TRANSLATE_BOARDS = 'RE_TRANSLATE_BOARDS';
export const RE_TRANSLATE_BOARDS_DONE = 'RE_TRANSLATE_BOARDS_DONE';
export const RE_TRANSLATE_BOARDS_FAILED = 'RE_TRANSLATE_BOARDS_FAILED';

export const BOARD_SETTINGS_USE_CASE_BOARD_DIALOG_OPENED = 'BOARD_SETTINGS_USE_CASE_BOARD_DIALOG_OPENED';
export const BOARD_SETTINGS_USE_CASE_BOARD_DIALOG_CLOSED = 'BOARD_SETTINGS_USE_CASE_BOARD_DIALOG_CLOSED';

export const UPDATE_USE_CASE_BOARD_SETTINGS = 'UPDATE_USE_CASE_BOARD_SETTINGS';
export const UPDATE_USE_CASE_BOARD_SETTINGS_DONE = 'UPDATE_USE_CASE_BOARD_SETTINGS_DONE';
export const UPDATE_USE_CASE_BOARD_SETTINGS_FAILED = 'UPDATE_USE_CASE_BOARD_SETTINGS_FAILED';

/**
 * Dispatch this action to load data.
 */
export const load = (requesterId, boardId) => {
  return {
    type: LOAD,
    requesterId,
    boardId
  }
}

export const _loadDone = (boardId, response) => {
  return {
    type: LOAD_DONE,
    boardId,
    response
  }
}

/**
 * Dispatch this action to stop live listning.
 */
export const disconnect = (requesterId, boardId) => {
  return {
    type: DISCONNECT,
    requesterId,
    boardId
  }
}

/**
 * Dipatch action to translate a given boards on given languages.
 */
export const translateBoard = (boardId, languages) => {
  return {
    type: TRANSLATE_BOARD,
    boardId,
    languages
  }
}

export const _translateBoardDone = (boardId, languages, response) => {
  return {
    type: TRANSLATE_BOARD_DONE,
    boardId,
    languages,
    response
  }
}

export const _translateBoardFailed = (boardId, languages, error) => {
  return {
    type: TRANSLATE_BOARD_FAILED,
    boardId,
    languages,
    error
  }
}

/**
 * Dipatch action to re-translate a given boards on given languages.
 */
export const retranslateBoard = (boardId) => {
  return {
    type: RETRANSLATE_BOARD,
    boardId,
  }
}

export const _retranslateBoardDone = (boardId) => {
  return {
    type: RETRANSLATE_BOARD_DONE,
    boardId,
  }
}

export const _retranslateBoardFailed = (boardId, error) => {
  return {
    type: RETRANSLATE_BOARD_FAILED,
    boardId,
    error
  }
}

/**
 * Dipatch action to re-translate multiple boards on given languages.
 * This is used when a user selects multiple boards and wants to re-translate them.
 * @param {string} boardId - The base board ID to re-translate.
 * @param {Array<string>} languages - The languages to re-translate the board into.
 */
export const reTranslateBoards = (boardId, languages) => {
  return {
    type: RE_TRANSLATE_BOARDS,
    boardId,
    languages
  }
}

export const _reTranslateBoardsDone = (boardId, languages, response) => {
  return {
    type: RE_TRANSLATE_BOARDS_DONE,
    boardId,
    languages,
    response
  }
}
export const _reTranslateBoardsFailed = (boardId, languages, error) => {
  return {
    type: RE_TRANSLATE_BOARDS_FAILED,
    boardId,
    languages,
    error
  }
}

/**
 * Updates the use case board settings.
 * @param {String} boardId - The ID of the board to update.
 * @param {Object} settings - The new settings for the use case board.
 * @returns {Object} The action object to be dispatched.
 */
export const updateUseCaseBoardSettings = (boardId, settings) => {
  return {
    type: UPDATE_USE_CASE_BOARD_SETTINGS,
    boardId,
    settings
  }
}

export const _updateUseCaseBoardSettingsDone = (boardId, settings) => {
  return {
    type: UPDATE_USE_CASE_BOARD_SETTINGS_DONE,
    boardId,
    settings
  }
}

export const _updateUseCaseBoardSettingsFailed = (boardId, settings, error) => {
  return {
    type: UPDATE_USE_CASE_BOARD_SETTINGS_FAILED,
    boardId,
    settings,
    error
  }
}